const API_URL = process.env.VUE_APP_API_URL
const getToken = () => localStorage.getItem('access-token')

export default {
  async getCustomersAPI (page = 1, limit = 10, search = '') {
    const response = await fetch(`${API_URL}/customer/customers?page=${page}&limit=${limit}&search=${search}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getToken()
      }
    })

    const resp = await response.json()
    if (!response.ok) {
      if (response.status === 400) {
        return Promise.reject(new Error(resp.error))
      }
    }
    return resp
  },

  async getCustomerByIdAPI (customerId) {
    const response = await fetch(`${API_URL}/customer/customers/${customerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getToken()
      }
    })

    const resp = await response.json()

    if (!response.ok) {
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async getMyCustomerDetailAPI () {
    const response = await fetch(`${API_URL}/customer/me`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getToken()
      }
    })

    const resp = await response.json()

    if (!response.ok) {
      if (response.status === 400) {
        throw new Error(resp.error)
      }
    }
    return resp
  },
  async getProvidersCatalogAPI () {
    const response = await fetch(`${API_URL}/customer/catalogs/providers`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getToken()
      }
    })
    const resp = await response.json()
    if (!response.ok) {
      if (response.status === 400) {
        return Promise.reject(new Error(resp.error))
      }
    }
    return resp
  }
}
